import {
    undef,
    allowFieldAutoSubmit,
    allowInputFieldErrorHighlighting,
    runHPGuestPickerCTASearchExperiment
} from './';

function hasEmptyGuestsCount(guestsCount) {
    return !guestsCount;
}

// eslint-disable-next-line no-unused-vars
function hasEmptyGuests(adultsCount, childrenCount, petIncluded) {
    return hasEmptyGuestsCount(adultsCount);
}

function hasEmptyGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasEmptyGuests(adultsCount, childrenCount, petIncluded);
}

function hasFilledGuestsCount(guestsCount) {
    return !hasEmptyGuestsCount(guestsCount);
}

/* istanbul ignore next */
// eslint-disable-next-line no-unused-vars
function hasFilledGuests(adultsCount, childrenCount, petIncluded) {
    return hasFilledGuestsCount(adultsCount);
}

/* istanbul ignore next */
function hasFilledGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasFilledGuests(adultsCount, childrenCount, petIncluded);
}

function hasValidGuestsCount(guestsCount) {
    return hasFilledGuestsCount(guestsCount);
}

// eslint-disable-next-line no-unused-vars
function hasValidGuests(adultsCount, childrenCount, petIncluded) {
    return hasValidGuestsCount(adultsCount);
}

function hasValidGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasValidGuests(adultsCount, childrenCount, petIncluded);
}

function shouldGuestsFieldAutoSubmitOnClose(mediaSettings, formOptions, guestsOptions, abacusStore, systemOptions, latestDestinationValues, latestDatesValues) {
    const {
        isMobile
    } = mediaSettings;

    return (
        isMobile && allowFieldAutoSubmit(formOptions, guestsOptions) ||
        runHPGuestPickerCTASearchExperiment(abacusStore, systemOptions, latestDestinationValues, latestDatesValues)
    );
}

function showGuestsInputFieldError(mediaSettings, formOptions, guestsOptions, latestGuestsValues) {
    const {
        isMobile
    } = mediaSettings;

    return !isMobile && (
        allowInputFieldErrorHighlighting(formOptions, guestsOptions) && !hasValidGuestsValues(latestGuestsValues)
    );
}

function showGuestsInputIcon(formOptions, guestsOptions) {
    const {
        showIcons
    } = formOptions;

    const {
        showInputIcon
    } = guestsOptions;

    return (
        showInputIcon ||
        showIcons && showInputIcon === undef
    );
}

export {
    hasEmptyGuests,
    hasEmptyGuestsCount,
    hasEmptyGuestsValues,
    hasFilledGuests,
    hasFilledGuestsCount,
    hasFilledGuestsValues,
    hasValidGuests,
    hasValidGuestsCount,
    hasValidGuestsValues,
    shouldGuestsFieldAutoSubmitOnClose,
    showGuestsInputFieldError,
    showGuestsInputIcon
};
